(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-wrapper"] && !Shopify.designMode) return;
  try {
    (function () {
    const handleProductBlockWrapperResize = () => {
      document.querySelectorAll('.product-block-wrapper').forEach((wrapperElement) => {
        const boxElement = wrapperElement.querySelector('.product-block-wrapper__box');
        wrapperElement.querySelector('button').style.display = boxElement.scrollHeight > boxElement.clientHeight + 1 ? '' : 'none';
      });
    };

    handleProductBlockWrapperResize();
    window.addEventListener('resize', handleProductBlockWrapperResize);

    document.querySelectorAll('.product-block-wrapper button').forEach((showMoreButton) => {
      showMoreButton.addEventListener('click',() => {
        showMoreButton.closest('.product-block-wrapper').dataset.expanded = 'true';
        showMoreButton.setAttribute('aria-expanded', 'true');
      }, { once: true });
    });
  })()
  } catch(e) { console.error(e); }
})();

})();
